export default __webpack_public_path__ + "fonts/ob_1.04529c85865de72d339bfdf296200553.png";